export interface updateEnterpriseUserRoleRequest {
  id: string
  role: string
}

export interface deleteEnterpriseUserRequest {
  userId: string
}

export interface deleteInvitationUserRequest {
  workspaceId: string
  teamId: string
  userId: string
  inviteMemberId: string
}

export interface inviteEnterpriseNewUserRequest {
  email: string
  role: string
}

interface SocialCheckInputItem {
  name: string
  nickname: string
  city: string
  state: string
  country: string
  email: string
  highSchool: string
  college: string
  phone: string
  twitterUrl: string
  facebookUrl: string
  instagramUrl: string
  linkedInUrl: string
  tikTokUrl: string
  ageOrDateOfBirth: string
}

export enum EReportType {
  AiAnalyst = 'ai_analyst_report',
  Ai = 'ai_report',
  AdverseMedia = 'adverse_media_report',
  Assited = 'assisted_report',
  FacialMatching = 'facial_matching',
}

export enum EWebhookEvent {
  N_A = 'n/a',
  SENT = 'form.sent',
  VIEWED = 'form.viewed',
  STARTED = 'form.started',
  COMPLETED = 'form.completed',
}

export enum ESocialCheckStatus {
  None = 'None',
  NotReleased = 'NotReleased',
  InQueue = 'InQueue',
  InProgress = 'InProgress',
  Complete = 'Complete',
  Error = 'Error',
  PendingDownloadPdf = 'PendingDownloadPdf',
  PendingReview = 'PendingReview',
  ErroPdf = 'ErrorPdf',
  Cancelled = 'Cancelled',
  PendingToScrapProfiles = 'PendingToScrapProfiles',
  ScrapeInProgress = 'ScrapeInProgress',
  IaAnalysisInProgress = 'IaAnalysisInProgress',
}

export interface UpdateEnterpriseData {
  enterpriseId: string
  companyName: string | undefined
  companyAddress: string | undefined
}
export enum EEnterpriseRole {
  OWNER = 'owner',
  CO_OWNER = 'co_owner',
  SUPERVISOR = 'supervisor',
  WORKSPACE_ADMIN = 'workspace_admin',
  MANAGER = 'manager',
  TEAM_MANAGER = 'team_manager',
  TEAM_ANALYST = 'team_analyst',
  OPERATIONAL_USER = 'operational_user',
  VIEW_USER = 'view_user',
  READER = 'reader',
}

export interface IExpiredReportItem {
  id: string
  subjectFullName: string
  originalCompletedAt: string
  deletedAt: string
  deletionReason: string
  enterprise: string
  requester?: string
  subjectInputs: SocialCheckInputItem
  reportType?: EReportType
}

export interface IExpiredReportsInfo {
  list: IExpiredReportItem[]
  page: number
  size: number
  pages: number
  offset: number
  totalItems: number
  currentItems: number
  reportRetentionDays: number
}

export interface IExpiredReportsResponse {
  message: string
  info: IExpiredReportsInfo
}

export interface GetExpiredReportsRequest {
  workspaceId?: string | null
  teamId?: string | null
  page: number
  pageSize: number
  searchByString?: string
}

export interface IExpiredReportsCache {
  list: IExpiredReportItem[]
  totalItems: number
  reportRetentionDays: number | null
}
